import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import MediaFrame from "@/components/feature/MediaFrame";
import { medicalPolicy } from "@/mocks/clinic";

export default function MedicalPolicy() {
  return (
    <section className="bg-background-50 py-24 md:py-32 lg:py-40">
      <div className="u-container">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[1.25fr_0.75fr] lg:gap-16">
          <Reveal>
            <SectionHeading en={medicalPolicy.headingEn} jp={medicalPolicy.headingJp} />
            <h3 className="mt-9 font-heading text-[22px] leading-[1.7] text-foreground-950 md:text-[28px] whitespace-pre-line">
              {medicalPolicy.lead}
            </h3>
            <div className="mt-8 space-y-7">
              {medicalPolicy.paragraphs.map((paragraph) => (
                <p key={paragraph} className="max-w-[46rem] text-[14px] leading-[1.9] text-foreground-800 md:text-[15px] md:leading-[2] lg:text-[16px]">
                  {paragraph}
                </p>
              ))}
            </div>

            <div className="mt-10 flex items-center gap-5 border-t border-background-300/80 pt-7">
              <span className="h-px w-10 bg-accent-500" />
              <div>
                <span className="en-eyebrow block text-[13px] tracking-[0.25em] text-foreground-900">
                  {medicalPolicy.doctor.nameEn}
                </span>
                <span className="mt-1 block text-[11px] tracking-[0.25em] text-foreground-600">
                  {medicalPolicy.doctor.role}
                </span>
              </div>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="flex h-full flex-col gap-4">
              <MediaFrame
                src={medicalPolicy.image}
                alt={medicalPolicy.imageAlt}
                objectPosition="object-center"
                className="h-[240px] w-full lg:h-[320px]"
              />
              <div className="rounded-lg border border-background-300/80 bg-background-100 p-6">
                <ul className="space-y-3.5">
                  {["医師の診察のもとでの施術", "看護師・カウンセラーの連携", "料金・治療後のご説明"].map((item) => (
                    <li key={item} className="flex items-center gap-3 text-[12px] text-foreground-700 md:text-[13px]">
                      <i className="ri-check-line text-accent-700" aria-hidden />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}